import { hydrateWidgets } from '@utils';
import { Storefront } from '../../widgets/DVWebNodeStorefront';
hydrateWidgets(Storefront);
